// useBasketButton.js
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addTrackBasket } from '../../../store/actions/basketActions';

const useBasketButton = (auth, track) => {
    const dispatch = useDispatch();
    const addTrackToBasket = useCallback(() => {
        const regButton = document.querySelector('[data-modal-open="modal--authorization"]');

        if (!auth && regButton) {
            regButton.click();
        } else {
            dispatch(addTrackBasket({ code_track: track.code }));
            if (typeof BX !== 'undefined' && BX.onCustomEvent) {
                BX.onCustomEvent('updateBasket', [track.id]);
            }
            console.log(`Track with id ${track.id} added to basket!`);
        }
    }, [auth, dispatch, track]);

    return [addTrackToBasket];
};

export default useBasketButton;